/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/start': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<circle pid="0" cx="6" cy="6" r="6" _fill="#fff"/><circle pid="1" cx="5.999" cy="6" r="5.216" _fill="#E25046"/>'
  }
})
